/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancerCompanyAddress } from './';
import {
    FreelancerCompanyAddressFromJSON,
    FreelancerCompanyAddressFromJSONTyped,
    FreelancerCompanyAddressToJSON,
} from './';
import type { VatStatus } from './';
import {
    VatStatusFromJSON,
    VatStatusFromJSONTyped,
    VatStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface DetailedCompanyInformationResponse
 */
export interface DetailedCompanyInformationResponse {
    /**
     * Official company name
     * @type {string}
     * @memberof DetailedCompanyInformationResponse
     */
    companyName: string;
    /**
     * 
     * @type {FreelancerCompanyAddress}
     * @memberof DetailedCompanyInformationResponse
     */
    address: FreelancerCompanyAddress;
    /**
     * Normalized registration number
     * @type {string}
     * @memberof DetailedCompanyInformationResponse
     */
    registrationNumber?: string;
    /**
     * Registration Office Information
     * @type {string}
     * @memberof DetailedCompanyInformationResponse
     */
    registrationOfficeInformation?: string;
    /**
     * VAT identification number
     * @type {string}
     * @memberof DetailedCompanyInformationResponse
     */
    vatNumber?: string;
    /**
     * 
     * @type {VatStatus}
     * @memberof DetailedCompanyInformationResponse
     */
    vatStatus?: VatStatus;
    /**
     * Company type ID based on legal form mapping
     * @type {string}
     * @memberof DetailedCompanyInformationResponse
     */
    companyTypeId?: string;
    /**
     * Map of legal attributes for form population
     * @type {{ [key: string]: string; }}
     * @memberof DetailedCompanyInformationResponse
     */
    legalAttributes: { [key: string]: string; };
}

/**
 * Check if a given object implements the DetailedCompanyInformationResponse interface.
 */
export function instanceOfDetailedCompanyInformationResponse(value: object): value is DetailedCompanyInformationResponse {
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('legalAttributes' in value) || value['legalAttributes'] === undefined) return false;
    return true;
}

export function DetailedCompanyInformationResponseFromJSON(json: any): DetailedCompanyInformationResponse {
    return DetailedCompanyInformationResponseFromJSONTyped(json, false);
}

export function DetailedCompanyInformationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DetailedCompanyInformationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'companyName': json['companyName'],
        'address': FreelancerCompanyAddressFromJSON(json['address']),
        'registrationNumber': json['registrationNumber'] == null ? undefined : json['registrationNumber'],
        'registrationOfficeInformation': json['registrationOfficeInformation'] == null ? undefined : json['registrationOfficeInformation'],
        'vatNumber': json['vatNumber'] == null ? undefined : json['vatNumber'],
        'vatStatus': json['vatStatus'] == null ? undefined : VatStatusFromJSON(json['vatStatus']),
        'companyTypeId': json['companyTypeId'] == null ? undefined : json['companyTypeId'],
        'legalAttributes': json['legalAttributes'],
    };
}

export function DetailedCompanyInformationResponseToJSON(value?: DetailedCompanyInformationResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companyName': value['companyName'],
        'address': FreelancerCompanyAddressToJSON(value['address']),
        'registrationNumber': value['registrationNumber'],
        'registrationOfficeInformation': value['registrationOfficeInformation'],
        'vatNumber': value['vatNumber'],
        'vatStatus': VatStatusToJSON(value['vatStatus']),
        'companyTypeId': value['companyTypeId'],
        'legalAttributes': value['legalAttributes'],
    };
}

